import axios from "axios";
import { API_URL } from "../../utils/DomainUtils";

//API for all other calls
export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// defining a custom error handler for all APIs
const errorHandler = error => {
  const statusCode = error.response?.status;

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.log(error);
  }

  return Promise.reject(error);
};

// registering the custom error handler to the
// "api" axios instance
api.interceptors.response.use(undefined, error => {
  return errorHandler(error);
});
